var commerceUtils = {
  minusPercent: function minusPercent(n, p) {
    return Number((n - n * p).toFixed(2));
  },
  convertToInches: function convertToInches(value) {
    return (value / 2.54).toFixed(2);
  },
  convertToCm: function convertToCm(value) {
    return (value * 2.54).toFixed(2);
  }
};
export default commerceUtils;